import GatherDisplay from './GatherDisplay'
import GatherForm from './GatherForm.container'
import IconDialPad from 'components/Icons/DialPad'

export default {
  id: 'gather',
  label: 'Gather Input',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/gather-input',
  icon: IconDialPad,
  inputs: [{}],
  outputs: [
    { name: '0', label: 'User pressed 0' },
    { name: '1', label: 'User pressed 1' },
    { name: '2', label: 'User pressed 2' },
    { name: '3', label: 'User pressed 3' },
    { name: '4', label: 'User pressed 4' },
    { name: '5', label: 'User pressed 5' },
    { name: '6', label: 'User pressed 6' },
    { name: '7', label: 'User pressed 7' },
    { name: '8', label: 'User pressed 8' },
    { name: '9', label: 'User pressed 9' },
    { name: '*', label: 'User pressed *' },
    { name: '#', label: 'User pressed #' },
    { name: 'X', label: 'User pressed nothing' },
  ],
  display: GatherDisplay,
  form: GatherForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Gather/index.js